module.exports = __webpack_public_path__ + "img/logo.c0e85f1a.png";